import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Form from 'component/commonReport/Form'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import moment from 'moment'
import CloseIconSVG from 'component/svgComponents/close'

class SideFilterForm extends Component {
  static propTypes = {
    submit: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    setSideFilterVisible: PropTypes.func.isRequired,
    handleFilter: PropTypes.func.isRequired,
    initialValues: PropTypes.object,
  }

  get formFields() {
    const { translate, initialValues } = this.props
    const [dtStart, dtEnd] = initialValues.dtPeriod || [false, false]

    return [
      {
        type: 'branchs',
        name: 'idBranches',
        label: translate('field.selectStore'),
        help_text: translate('totalAccuracy.store'),
        required: true,
        initial: initialValues.idBranches,
      },
      {
        type: 'date_range',
        name: 'dtPeriod',
        label: translate('field.period.hint'),
        showHelperArea: true,
        help_text: translate('totalAccuracy.dtYear.filter'),
        required: true,
        initial: initialValues.dtPeriod,
        attrs: {
          initialValue: [moment(dtStart), moment(dtEnd)],
        },
      },
      {
        type: 'radio_group',
        title: translate('option.time'),
        name: 'time',
        required: true,
        options: [
          { value: 4, label: translate('totem.reports.time.options.above') },
          { value: 3, label: translate('totem.reports.time.options.under') },
          {
            value: 2,
            label: translate('totem.query.log.sales.order.deleted.option'),
          },
          { value: 1, label: translate('totem.reports.time.options.all') },
        ],
        initial: initialValues.time,
      },
      {
        type: 'radio_group',
        title: translate('totemReports.weight'),
        name: 'weight',
        required: true,
        options: [
          { value: 3, label: translate('totemReports.aboveWeight') },
          { value: 2, label: translate('totemReports.belowWeight') },
          { value: 1, label: translate('totem.reports.time.options.all') },
        ],
        initial: initialValues.weight,
      },
      {
        type: 'radio_group',
        title: translate('totem.reports.modal.order.detail.table.qnt'),
        name: 'quantity',
        required: true,
        options: [
          { value: 3, label: translate('totemReports.someItems') },
          { value: 2, label: translate('totemReports.aboveItems') },
          { value: 1, label: translate('totem.reports.time.options.all') },
        ],
        initial: initialValues.quantity,
      },
    ]
  }

  render() {
    const { translate, setSideFilterVisible, handleFilter } = this.props

    return (
      <Fragment>
        <div className='bg-filter' onClick={setSideFilterVisible} />
        <div className='right-filter-container'>
          <CloseIconSVG  className="right-filter-svg" onClick={setSideFilterVisible} />
          <h3 className='margin-bottom-triple'>
            <strong>{translate('mobile.filter')}</strong>
          </h3>
          <Form
            fields={this.formFields}
            onSubmit={(values) => handleFilter(values)}
            translate={translate}
            buttonCompleteWidth
          />
        </div>
      </Fragment>
    )
  }
}

const SideFilterFormTranslated = translate(null, { wait: true })(SideFilterForm)

export default connect()(SideFilterFormTranslated)

export { SideFilterForm }
